/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Metapic Internal Payments API Documentation
 * <p>API documentation for Metapic internal APIs. This documentation covers payment-related endpoints including payment summaries, cost summaries, payout history, and general payment operations.</p>
      <h2>Authentication</h2>
      <p>This API uses <strong>Bearer Token</strong> authentication. You must include a valid token in the <strong>Authorization</strong> header with every request to access protected endpoints.</p>
      <h4>Example:</h4>
      <pre>Authorization: Bearer <i>your_token_here</i></pre>
      <p>*Replace <i>your_token_here</i> with your actual Bearer token. All API requests require this token for authentication.</p>
 * OpenAPI spec version: 1.0
 */
import * as axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import type {
  AffiliateLinkMetrics,
  AffiliateLinkMetricsControllerGetMetricsParams,
} from '../metapicInternalPaymentsAPIDocumentation.schemas'

export const getAffiliateLinkMetrics = (axiosInstance: AxiosInstance = axios.default) => {
  /**
   * Returns lifetime (or date-ranged) metrics for one affiliate link, aggregated across all traffic sources. Monetary fields are named from Metapic’s perspective: cost_* is what Metapic pays out, revenue_* is what Metapic bills the advertiser. Fields the caller is not permitted to read are omitted from the response.
   * @summary Aggregated metrics for a single affiliate link
   */
  const affiliateLinkMetricsControllerGetMetrics = (
    id: number,
    params?: AffiliateLinkMetricsControllerGetMetricsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<AffiliateLinkMetrics>> => {
    return axiosInstance.get(`/performance/affiliate-links/${id}/metrics`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  return { affiliateLinkMetricsControllerGetMetrics }
}
export type AffiliateLinkMetricsControllerGetMetricsResult = AxiosResponse<AffiliateLinkMetrics>
